import {SxType} from "@baseTypes/sx/sxTypes";
import {SV_DARK, SV_LIGHT} from "@containers/singleVoyage/views/constants/theme";

export const sx: SxType = {
    label: {
        fontSize: '12px',
        fontWeight: 500,
        lineHeight: '16px',
        letterSpacing: 0,
        '.lightTheme &': {
            color: SV_LIGHT.text2
        },
        '.darkTheme &': {
            color: SV_DARK.text2
        },
        '&.secondary':{
            paddingTop:'5px',
            paddingRight:'10px',
            fontWeight: 600,
            fontSize: '12px',
            minWidth:'65px',
            '.lightTheme &': {
                color: SV_LIGHT.text
            },
            '.darkTheme &': {
                color: SV_DARK.text
            },
        }
    }
}
